import {
  BusinessOutlined,
  DriveFolderUploadOutlined,
  FolderSpecialOutlined,
  WorkOutline,
} from "@mui/icons-material";
import type { SvgIconProps } from "@mui/material";

/** The Secure Exchange tile's icon on the Home page. */
export const ExchangeIcon = (props: SvgIconProps) => (
  <DriveFolderUploadOutlined {...props} />
);
export const ClientIcon = (props: SvgIconProps) => (
  <BusinessOutlined {...props} />
);
export const ProjectIcon = (props: SvgIconProps) => <WorkOutline {...props} />;
export const CollectionIcon = (props: SvgIconProps) => (
  <FolderSpecialOutlined {...props} />
);
